var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProgramFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_22356)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_589_22356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1472 36.457L1.16309 26.1201L13.213 18.4538L1.16309 10.7939L17.1472 0.457031L19.5767 4.2088L9.44172 10.7614L21.5438 18.4538L9.44172 26.1527L19.5767 32.6988L17.1472 36.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4408 36.457L14.4502 26.1201L26.5066 18.4538L14.4502 10.7939L30.4408 0.457031L32.8638 4.2088L22.7353 10.7614L34.8374 18.4538L22.7353 26.1527L32.8638 32.6988L30.4408 36.457Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_22356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.457031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_589_22356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6747,
    height: 36,
    fill: "white",
    transform: "translate(1.16309 0.457031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProgramFocus);
export default __webpack_public_path__ + "static/media/icProgramFocus.d608866bf20a950a67f031d7cb9d16b4.svg";
export { ForwardRef as ReactComponent };